import { useLocation } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";

import { Spacing, SpacingSizes } from "@components/Spacing";
import { useSentShareGoalInvites } from "@hooks";
import { ShareGoalRouteParams } from "@routes/ShareGoalRoute/types";
import { InviteContactItem } from "./InviteContactItem";

export const InviteContactList = () => {
  const location = useLocation();

  const goalId = (location.state as ShareGoalRouteParams).goalId;

  const { data: invites } = useSentShareGoalInvites({ goalId });

  if (!invites?.length) return null;

  return (
    <>
      {invites.map((invite, index) => {
        if (!invite?.id || !invite.phoneNumber || !invite.status || !invite.goalId) {
          return null;
        }

        const { id, phoneNumber, status, goalId } = invite;

        return (
          <Fragment key={`share-goal-invite-${index}`}>
            <InviteContactItem
              key={index}
              id={id}
              phoneNumber={phoneNumber}
              status={status}
              goalId={goalId}
            />
            <Spacing size={SpacingSizes.S} />
          </Fragment>
        );
      })}
    </>
  );
};
